import { Link } from "react-router-dom"
import styles from "./ForAnyAssistance.module.css"
import ArrowInsideCircleIcon from "@assets/icons/arrowInsideCircle"

const ForAnyAssistance = () => {
  return (
    <>
      <div className={styles.moreAppsCardWrapper}>
        <div className={styles.content}>
          <div className={styles.headerWrapper}>
            <h3 className={styles.heading}>FOR ANY ASSISTANCE</h3>
            <Link to={"/contact"}>
              <ArrowInsideCircleIcon />
            </Link>
          </div>
          <h6 className={styles.description}>
            Orbsway is ready to help you. Contact Us with your concerns anytime.
          </h6>
        </div>
      </div>
    </>
  )
}

export default ForAnyAssistance
